import { Component, OnInit } from '@angular/core';

import { NavigationService } from './navigation.service';
import { AppConfigService } from '../services/config.service';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.css']
})
export class NavigationComponent implements OnInit {

    constructor(private _navigationService: NavigationService,
                public configService: AppConfigService) { }

    navigation: any[] = [];
    primaryColor: string;
    ngOnInit() {
      if (this.configService.get('SIGLE') === 'SIR') {
        this.primaryColor = '#198754';
      } else {
        this.primaryColor = '#F36F21';
      }
      document.documentElement.style.setProperty('--primary-color', this.primaryColor);
      this.navigation = this._navigationService.getNavigation();
    }

}
